var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg2Svg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 140,
    viewBox: "0 0 140 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 70,
    cy: 70,
    r: 70,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M91.9453 84.5715C91.9713 90.3178 87.3326 94.9928 81.5916 95.0188C75.8453 95.0448 71.1702 90.4062 71.1442 84.6651C71.139 83.7239 71.2638 82.7878 71.5082 81.883L60.5929 76.4227C57.0515 80.9469 50.5148 81.7426 45.9906 78.2012C41.4663 74.6598 40.6707 68.1231 44.2121 63.5989C47.7534 59.0746 54.2902 58.279 58.8144 61.8204C59.4748 62.3404 60.0729 62.9332 60.5929 63.5989L71.5082 58.1386C70.0158 52.5795 73.3075 46.8592 78.8666 45.3615C84.4257 43.8639 90.1408 47.1556 91.6385 52.7147C93.1361 58.2738 89.8444 63.9889 84.2853 65.4866C80.2499 66.5734 75.9545 65.1433 73.3751 61.8568L62.4598 67.317C62.9486 69.0799 62.9486 70.9416 62.4598 72.6993L73.3751 78.1596C76.9113 73.6406 83.4376 72.8397 87.9567 76.3759C90.4788 78.3468 91.9505 81.3682 91.9453 84.5715Z",
    fill: "#FF7FFB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg2Svg);
export default __webpack_public_path__ + "static/media/2_svg.3c89f51ac1186af0d279650613648d66.svg";
export { ForwardRef as ReactComponent };